import { render, staticRenderFns } from "./BrewVoteDisplay.vue?vue&type=template&id=9dc29a40&scoped=true"
import script from "./BrewVoteDisplay.vue?vue&type=script&lang=js"
export * from "./BrewVoteDisplay.vue?vue&type=script&lang=js"
import style0 from "./BrewVoteDisplay.vue?vue&type=style&index=0&id=9dc29a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc29a40",
  null
  
)

export default component.exports